<!-- Impersonation banner-->
<div class="fixed-top bg-primary text-white shadow fadeIn" *ngIf="isImpersonating" style="z-index: 9999;">
  <div class="container-fluid">
    <div class="row py-2 px-3">
      <div class="col-12 col-md-auto d-flex align-items-center gap-2 mb-2 mb-md-0"><strong class="text-uppercase small fw-bold ls-1" style="letter-spacing: 0.5px;">Support Mode Active</strong><span class="small opacity-75">Viewing as {{ impersonationData?.impersonator_email || 'unknown user' }}</span></div>
      <div class="col-12 col-md-auto ms-md-auto d-flex align-items-center gap-3 justify-content-center justify-content-md-end"><span class="badge bg-white bg-opacity-25 fw-semibold" *ngIf="timeRemaining > 0">Session expires in {{ timeRemainingFormatted }}</span>
        <button class="btn btn-light btn-sm fw-bold" type="button" (click)="exitImpersonation()">Exit Support Mode</button>
      </div>
    </div>
  </div>
</div>
